import React from "react";
import "react-tabs/style/react-tabs.css";
import { Form } from "react-bootstrap";
import { Button } from "react-bootstrap";
import { Card } from "react-bootstrap";
import { Col } from "reactstrap"; //CardImg,
import { Breadcrumb } from "react-bootstrap";
import MUIDataTable from "mui-datatables";
import { connect } from "react-redux";
import { logincheck } from '../Userlogin/Userlogin'

class Thankyou extends React.Component {
  state = {};
  constructor(props) {
    super(props);
    
    this.addmoney = this.addmoney.bind(this);
    this.state = {
      tabs: ["", "", ""],
      tabPanel: ["", "", ""],
      tabPanel0: "",
      tabPanel1: "",
      tabPanel2: "",
      modal: false,
      userData: [],
      amount:0 
    };
    // this.submitHandler = this.submitHandler.bind(this);
  }

  nextPath(path, value) {
    this.props.history.push({ pathname: path, data: value, state: { data: value } });
  }
  addmoney () {
    this.props.history.push({ pathname: "/wallet/addmoney" });
  }
  componentDidMount() {
    
	
	  logincheck(this.props.userId, this.props.mobiledevice).then(({ data: data }) => {
				console.log(data.status_check)
				if(data.status_check === 0) {
					this.props.history.push({ pathname: `/Logout`, state: { userId : this.props.userId , logintoken: 2 } });
				}
			}) 
    let postAddressData = { user_id : this.props.userId }
    fetch(process.env.REACT_APP_NODE_ENV + '/api/wallet/amount', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
      },
      body: JSON.stringify(postAddressData)
    }).then((response) => response.json())
      .then(data => {
        this.setState({ amount : data.wallet_amount })
       
        //console.log(data.wallet_amount)
      })
    
  }

  // delete = (id) => {
  //   const postApartmentCustomerData = {
  //     id: id
  //   };
  //   console.log(postApartmentCustomerData);
  //   fetch('/api/apart-customer/delete', {
  //     method: 'DELETE',
  //     headers: {
  //       'Content-Type': 'application/json'
  //     },
  //     body: JSON.stringify(postApartmentCustomerData)
  //   }).then(response => { if (response.ok) { this.componentDidMount() } })
  //     .then(data => console.log(data))
  //     .catch((err) => console.log(err))
  // };

  render() {
    // let userdatas = this.state.userData.map((data, index) => {
    //   return (
    //     <tr key={index}><td>{index + 1}</td><td>{data.id}</td>
    //       <td>{data.apartmentName}</td>
    //       <td>{data.apartmentPhoneNo}</td>
    //       <td>{data.doorNo + ", " + data.streetName + ", " + data.area}</td>
    //       <td> {data.city}</td>
    //       <td> {data.landmark}</td>
    //       <td><Button variant="outline-success" onClick={() => this.nextPath("/aprt-customer/customer-details", data.id)} >
    //         Details </Button></td></tr>)
    // });

    let dataArr = [];
    this.state.userData.map((data) => {
      let mdData = [
        data.individualId,
        data.name, data.alternateNumber, data.doorNumber + "," + data.streetName + "," + data.area + "," + data.city, data.landmark, data.id
      ];
      dataArr.push(mdData)
      return null;
    });


    const columns = [
      {
        name: "id",
        label: "Id",
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: "name",
        label: "Name",
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: "alternateNumber",
        label: "Alternate Phone Number",
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: "address",
        label: "Address",
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: "landmark",
        label: "Landmark",
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: "actions",
        label: "Actions",
        options: {
          filter: false,
          sort: false,
          customBodyRender: (value, tableMeta, updateValue) => {
            return (
              <><Button variant="outline-success" onClick={() => this.nextPath("/indiv-customer/customer-details", value)} >
                Details </Button>
                {/* &nbsp;&nbsp;&nbsp;<Button variant="outline-danger" onClick={() => this.delete(value)} >
                  Delete </Button>  */}
              </>
            );
          }
        }
      }
    ];


    const options = {
      filterType: 'dropdown', rowsPerPageOptions: [5, 10, 15, 20], selectableRows: "none"
      // ,
      // onRowsDelete: (rowsDeleted) => {
      //   for (var key in rowsDeleted.data) {
      //     console.log(rowsDeleted.data[key].index)
      //     this.delete(dataArr[rowsDeleted.data[key].index].id)
      //   }
      // }
    };

    if (this.props.userRole === "Administrator" || this.props.userRole === "Super Admin" || this.props.userRole === "Support User" || this.props.userRole === "Individual Customer" ||  this.props.userRole == 'Apartment Customer') {
      return (
        <>
          <Breadcrumb>
            <Breadcrumb.Item active>Thankyou</Breadcrumb.Item>
          </Breadcrumb>

          <div style={{ marginTop: "10px" }}>   
          <Card className="text-center">
  <Card.Header>
  <div style={{ fontSize: "20px",border: '1px solid #4cb54c' , borderRadius: '50%', background : '#4cb54c', color: '#fff', width: '40px', margin:'0 auto'  }}><i class="kt-menu__link-icon flaticon2-check-mark"></i> </div>
      <h1 style={{ color: "green" }}>Payment Successful</h1>
  </Card.Header>
  <Card.Body>
      <Card.Title style= {{ fontSize: "15px" }}>Your wallet amount RS. { this.state.amount }  </Card.Title>
    <Card.Text  style= {{ fontSize: "15px" }}>
      Thank You For Adding Amount in the wallet
    </Card.Text>
    <Button  variant="outline-success" onClick={this.addmoney}>Go Back</Button>
  </Card.Body>
  
</Card>
            

          </div>
        </>
      );
    } else {
      return (<></>);
    }

  }
}

const mapStateToProps = (state /*, ownProps*/) => {
  return {
    userRole: state.auth.user[0].userType,
    userId: state.auth.user[0].id,
	mobiledevice: state.auth.user[0].mobiledeviceId,
  }
}

export default connect(
  mapStateToProps,
  null
)(Thankyou)